<ion-content *ngIf="groupedActivities$ | async as groupedActivities" class="no-scroll" #content [ngClass]="{'vectorimageleft' : (!(groupedActivities && groupedActivities.length) && activityService.noActivityConfirmation && !activityService.activitiesSearchText)}">
    <div [ngSwitch]="agendaFooterService.actSegment" *ngIf="activityService.displayActivities && hasBaselineEnabled" class="activityMode">
        <div *ngSwitchCase="'agenda'" class="activityMode-agenda agenda-view">
            <ng-container *ngIf="deltaService.isInitialSyncFinished; else snapshot">
              <div *ngIf="!(groupedActivities && groupedActivities.length) && activityService.noActivityConfirmation && !activityService.activitiesSearchText" class="no-data-message">
                  {{'NO_ACTIVITIES' | translate}}
              </div>

              <ng-container *ngIf="groupedActivities && groupedActivities.length>0">
                <div #scroller class="activity-list allow-scroll-bar" (scroll)="onScroll($event)">
                  <div class="activity-list-spacer" [style.height.px]="totalHeight"></div>
                  <div class="activity-list-content" [style.transform]="'translateY(' + topPad + 'px)'">
                    <div *ngFor="let activity of visibleItems; trackBy: trackByActivityId"
                      [ngClass]="activity?.isDivider ? 'activity-divider' : 'activity-item'">
                      <ind-section-header *ngIf="activity?.isDivider" [viewData]="activity?.view"></ind-section-header>
                      <div class="no-activity" *ngIf="activity?.noActivity">{{'NOTHING_SCHEDULED_FOR_TODAY' | translate}} </div>
                      <main-card *ngIf="!activity?.isDivider && !activity?.noActivity" [viewData]="getMainCardDataModel(activity)"></main-card>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="activityService.activitiesSearchText && (!groupedActivities || groupedActivities.length==0)">
                  <ind-no-search-result [text]="('NO_RESULTS_FOR_THIS_SEARCH' | translate)"></ind-no-search-result>
              </ng-container>
            </ng-container>

            <ng-template #snapshot>
                <ng-container *ngIf="!deltaService.isInitialSyncFinished && activityService.snapshot; else initializing;">
                    <div *ngFor="let viewPortItem of activityService.snapshot; let i = index; trackBy: trackByIndex">
                        <ind-section-header *ngIf="viewPortItem.isDivider" [viewData]="viewPortItem.view"></ind-section-header>
                        <main-card *ngIf="!viewPortItem.isDivider" [viewData]="viewPortItem"></main-card>
                    </div>
                </ng-container>
            </ng-template>

            <ng-template #initializing>
                <ion-list>
                    <ind-section-header [isSkeleton]="true"></ind-section-header>
                    <ng-container *ngFor="let i of [].constructor(numberOfSkeletonCardsToDisplay); let idx = index; trackBy: trackByIndex">
                        <main-card [isSkeleton]="true"></main-card>
                    </ng-container>
                </ion-list>
            </ng-template>
        </div>

        <div *ngSwitchCase="'week'" class="week-view">
            <activity-calendar [calendarSearchText]="activityService.activitiesSearchText"></activity-calendar>
        </div>

        <div *ngSwitchCase="'scheduler'" class="scheduler-view">
            <scheduler-list [schedulerSearchText]="activityService.activitiesSearchText"></scheduler-list>
        </div>
        <div [ngClass]="{'disabled' : device.isOffline}" *ngSwitchCase="'approvals'" class="approvals-view">
          <app-approval-list></app-approval-list>
        </div>
    </div>
    <div class="no-data-message" *ngIf="!hasBaselineEnabled">
        {{'NO_ACCESS_TO_OMNIPRESENCE' | translate}}
    </div>
</ion-content>
